import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-skeleton',
  styleUrl: 'signet-skeleton.scss',
})
export class SignetSkeleton {
  @Prop() shape: 'circle' | 'button' | 'paragrah';
  @Prop() avatar: boolean;
  @Prop() basic: boolean;
  @Prop() article: boolean;

  render() {
    const classes = {
      'signet-skeleton': true,
      [`signet-skeleton-${this.shape}`]: true,
    };

    if (this.article) {
      return (
        <div class="signet-skeleton-article">
          <div class="signet-skeleton signet-skeleton-circle"></div>
          <div class="paragraphs">
            <div class="signet-skeleton signet-skeleton-paragraph"></div>
            <div class="buttons">
              <div class="signet-skeleton signet-skeleton-button"></div>
              <div class="signet-skeleton signet-skeleton-button"></div>
            </div>
            <div class="signet-skeleton signet-skeleton-button"></div>
          </div>
        </div>
      );
    }

    if (this.basic) {
      return (
        <div class="signet-skeleton-basic">
          <div class="signet-skeleton signet-skeleton-paragraph"></div>
          <div class="signet-skeleton signet-skeleton-paragraph"></div>
          <div class="signet-skeleton signet-skeleton-paragraph"></div>
        </div>
      );
    }

    if (this.avatar) {
      return (
        <div class="signet-skeleton-avatar">
          <div class="signet-skeleton signet-skeleton-circle"></div>
          <div class="signet-skeleton signet-skeleton-button"></div>
        </div>
      );
    }

    return <div class={classes}></div>;
  }
}
